// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__17YTd","content":"styles_content__1_q84","checkbox":"styles_checkbox__2I1IB","checkboxLabel":"styles_checkboxLabel__2E6Dy"};